// extracted by mini-css-extract-plugin
export default {"loaderContainer":"LoaderOverlay_loaderContainer__XWIp9","spinner":"LoaderOverlay_spinner__OEtuI"};